var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBubbleChatQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 9.63926C18.3332 14.0419 14.6017 17.6115 9.99984 17.6115C9.45874 17.6122 8.91921 17.5622 8.38768 17.4624C8.00511 17.3905 7.81382 17.3546 7.68028 17.375C7.54673 17.3954 7.35749 17.496 6.97899 17.6973C5.90829 18.2667 4.6598 18.4678 3.4591 18.2445C3.91545 17.6832 4.22713 17.0097 4.36465 16.2876C4.44799 15.846 4.2415 15.417 3.93225 15.1029C2.52762 13.6766 1.6665 11.7546 1.6665 9.63926C1.6665 5.23663 5.39799 1.66699 9.99984 1.66699C14.6017 1.66699 18.3332 5.23663 18.3332 9.63926Z",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 8.20545C8.33301 7.35578 9.0792 6.66699 9.99967 6.66699C10.9201 6.66699 11.6663 7.35578 11.6663 8.20545C11.6663 8.51172 11.5694 8.79709 11.4023 9.03683C10.9042 9.75136 9.99967 10.4327 9.99967 11.2824V11.667",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.75H10.0075",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBubbleChatQuestion);
export default __webpack_public_path__ + "static/media/icon-bubble-chat-question.42a7a434071ecacca822b30b3a364322.svg";
export { ForwardRef as ReactComponent };